import decorateWithVisitorTypeTransform from './decorateWithVisitorTypeTransform';
import decorateFieldWithShowIf from './decorateFieldWithShowIf';
import decorateFieldWithShowForVisitorType from './decorateFieldWithShowForVisitorType';
import filterByLastCompletedStep from './filterByLastCompletedStep';
import filterCompletedFields from './filterCompletedFields';
import filterDuplicateFieldIdPerStep from './filterDuplicateFieldIDPerStep';
import filterFields from './filterFields';
import filterByShowBoolean from './filterByShowBoolean';
import decorateWithUIOverrides from './decorateWithUIOverrides';
import decorateWithConditionalDefaultValues from './decorateWithConditionalDefaultValues';
import decorateWithGDPRCompliance from './decorateWithGDPRCompliance';

const sortAscending = (steps: any) =>
  steps.sort((a: any, b: any) => a.stepId - b.stepId);

const dataTransform = (state: any, props: any) => {
  const { data } = props;
  const { steps, requiresGDPRCompliance, completedFields } = data;
  const { formState, collegePill, personalizationCompleted } = state;

  const visitorType = decorateWithVisitorTypeTransform(steps);
  const showIf = decorateFieldWithShowIf(
    visitorType,
    formState,
    data.currentVisitorType
  );
  const showForVisitorType = decorateFieldWithShowForVisitorType(
    showIf,
    formState,
    data
  );
  const lastCompletedStep = filterByLastCompletedStep(showForVisitorType, data);

  const removeDuplicateFieldIDPerStep = filterDuplicateFieldIdPerStep(
    lastCompletedStep,
    formState,
    data
  );

  const filteredFields = filterFields(removeDuplicateFieldIDPerStep);
  const completedFieldsList = filterCompletedFields(
    completedFields,
    filteredFields
  );

  const filteredByShowBoolean = filterByShowBoolean(completedFieldsList);
  const withUIOverrides = decorateWithUIOverrides(filteredByShowBoolean);
  const withConditionalDefaultValues = decorateWithConditionalDefaultValues(
    withUIOverrides,
    formState
  );
  const sorted = sortAscending(withConditionalDefaultValues);
  const stepsToUse = requiresGDPRCompliance
    ? decorateWithGDPRCompliance(sorted)
    : sorted;

  formState.institution_name = data.institution_name;

  let currentStep = 0;

  if (state.currentStep === 0 && data.lastCompletedStep) {
    for (let index = 0; index < stepsToUse.length; index += 1) {
      if (stepsToUse[index].stepId > data.lastCompletedStep) {
        currentStep = index;
        break;
      }
    }
  }

  return {
    // Add gdpr check to first step if required by apo
    tour: state.tour,
    analyticsData: state.analytics,
    steps: stepsToUse,
    // Determines if current step is step that requires gdpr checkmark
    stepRequiresGDPRValidation:
      state.currentStep === 0 && requiresGDPRCompliance,
    numberOfSkippedSteps: steps
      // .concat()
      .filter(
        ({ stepId }: any) =>
          parseInt(stepId, 10) > parseInt(data.lastCompletedStep, 10)
      ).length,
    formData: data,
    formState,
    currentStep: (currentStep === 0 && state.currentStep) || currentStep,
    completed: state.completed,
    title: state.tour.title || data.title,
    subtitle: state.tour.subtitle || data.subtitle,
    successTitle: state.tour.successTitle || data.success_title,
    successSubtitle: state.tour.successSubtitle || data.success_subtitle,
    successDescription:
      state.tour.successDescription || data.success_description,
    large_form_image: data.large_form_image,
    collegePills: collegePill,
    personalizationCompleted,
  };
};

export default dataTransform;
